import React, { useEffect, useState } from 'react';

const PieProgress = ({
                         percentage = 0,
                         size = 120,
                         bkStrokeWidth = 8,
                         focusStrokeWidth = 10,
                         focusStartColor = '#661F89',
                         focusEndColor = '#C046D0',
                         backgroundColor = '#C1B4CB',
                         animationDuration = 1500,
                         children
                     }) => {
    const [animatedPercentage, setAnimatedPercentage] = useState(0);

    useEffect(() => {
        setAnimatedPercentage(0);
        const startTime = Date.now();
        const animate = () => {
            const elapsed = Date.now() - startTime;
            const progress = Math.min(elapsed / animationDuration, 1);

            // 使用 easeOutCubic 緩動函數，讓動畫更自然
            const easeProgress = 1 - Math.pow(1 - progress, 3);
            setAnimatedPercentage(percentage * easeProgress);

            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        };

        requestAnimationFrame(animate);
    }, [percentage, animationDuration]);
    
    const viewSize = size + 10;
    const radius = (size - bkStrokeWidth) / 2;
    const circumference = radius * 2 * Math.PI; // 圓周長公式：2πr
    const offset = circumference - (animatedPercentage / 100) * circumference;

    return (
        <div className="pie-progress-root">
            <svg width={viewSize} height={viewSize} viewBox={`-5 -5 ${viewSize} ${viewSize}`}>
                <defs>
                    <linearGradient id="gradientStroke" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor={focusStartColor} />
                        <stop offset="100%" stopColor={focusEndColor} />
                    </linearGradient>
                    <filter id="dropShadow" x="-50%" y="-50%" width="200%" height="200%">
                        <feDropShadow
                            dx="0"
                            dy="0"
                            stdDeviation="6"
                            floodColor="rgba(0,0,0,0.3)"
                        />
                    </filter>
                </defs>

                <circle
                    cx={`${size / 2}px`}
                    cy={`${size / 2}px`}
                    r={radius}
                    stroke={backgroundColor}
                    strokeWidth={`${bkStrokeWidth}px`}
                    fill="transparent"
                    shapeRendering="geometricPrecision"
                    filter="url(#dropShadow)"
                />
                <circle
                    cx={`${size / 2}px`}
                    cy={`${size / 2}px`}
                    r={radius}
                    stroke="url(#gradientStroke)"
                    strokeWidth={`${focusStrokeWidth}px`}
                    fill="transparent"
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    strokeLinecap="round"
                    shapeRendering="geometricPrecision"

                />

                {/* 進度起始點的裝飾小圓 */}
                <circle
                    cx={`${size - (focusStrokeWidth / 2)}px`}
                    cy={`${size / 2}px`}
                    r={focusStrokeWidth / 6}
                    fill={focusStartColor}
                    filter="url(#dropShadow)"
                />
            </svg>

            {children}
        </div>
    );
};

export default PieProgress;